import Logout from '.';
import { IRoute } from '../../utils/navigation/routes';

export const logoutRoutes: IRoute[] = [{ path: '/logout', element: <Logout /> }];
